export const VERSION = {
    "version": "3.12.9"
};
